import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routerObject = [
  {
    redirect: '/home',
    path: '/'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home'),
    meta: {
      title: '首页',
      showNav: true // 是否展示在导航栏
    }
  },
  {
    path: '/industry',
    name: 'industry',
    component: () => import('../views/industry'),
    meta: {
      title: '产业情报',
      showNav: true, // 是否展示在导航栏,
      showChannelSetting: true // 是否显示
    },
  },
  {
    path: '/industryInfo',
    name: 'industryInfo',
    component: () => import('../views/industry/industryInfo'),
    meta: {
      title: '产业情报',
      showNav: false, // 是否展示在导航栏,
      showChannelSetting: true // 是否显示
    },
  },
  {
    path: '/selectResult',
    name: 'selectResult',
    component: () => import('../views/home/selectResult'),
    meta: {
      title: '搜索结果',
      showNav: false, // 是否展示在导航栏
      showChannelSetting: true // 是否显示
    }
  },
  {
    path: '/enterpriseExam',
    name: 'enterpriseExam',
    component: () => import('../views/enterpriseExam'),
    meta: {
      title: '企业测评',
      showNav: true // 是否展示在导航栏
    }
  },
  {
    path: '/enterpriseTrain',
    name: 'enterpriseTrain',
    component: () => import('../views/enterpriseTrain'),
    meta: {
      title: '企业培训',
      showNav: true // 是否展示在导航栏
    }
  },
  {
    path: '/enterpriseTrain/module',
    name: 'enterpriseTrain-module',
    component: () => import('../views/enterpriseTrain/module'),
    meta: {
      title: '培训详情列表',
      showNav: false // 是否展示在导航栏
    }
  }, {
    path: '/enterpriseTrain/module/detail',
    name: 'enterpriseTrain-module-detail',
    component: () => import('../views/enterpriseTrain/moduleDetail'),
    meta: {
      title: '培训详情',
      showNav: false // 是否展示在导航栏
    }
  },
  {
    path: '/moreCourseView',
    name: 'moreCourseView',
    component: () => import('../views/enterpriseTrain/moreCourseView'),
    meta: {
      title: '更多课程',
      showNav: false // 是否展示在导航栏
    }
  },
  {
    path: '/industryMoreData',
    name: 'industryMoreData',
    component: () => import('../views/industry/industryMoreData'),
    meta: {
      title: '产业情报更多数据',
      showNav: false, // 是否展示在导航栏
      showChannelSetting: true // 是否显示
    }
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service'),
    meta: {
      title: '服务严选',
      showNav: true // 是否展示在导航栏
    }
  },
  {
    path: '/service/detail',
    name: 'service-detail',
    component: () => import('../views/service/serviceInfo'),
    meta: {
      title: '严选详情',
      showNav: false// 是否展示在导航栏
    }
  },
  {
    path: '/tools',
    name: 'tools',
    component: () => import('../views/tools'),
    meta: {
      title: '活动资讯',
      showNav: true // 是否展示在导航栏
    }
  },
  {
    path: '/tools/detail',
    name: 'tools-detail',
    component: () => import('../views/tools/toolsInfo'),
    meta: {
      title: '活动详情',
      showNav: false// 是否展示在导航栏
    }
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('../views/personal'),
    redirect: '/personal/home',
    meta: {
      title: '我的VIP',
      showNav: true // 是否展示在导航栏
    },
    children: [
      {
        path: 'home',
        name: 'personalHome',
        component: () => import('../views/personal/personalHome')
      },
      {
        path: 'buyPersonal',
        name: 'buyPersonal',
        component: () => import('../views/personal/buyPersonal'),
        meta: {
          hiddenFooter: true
        }
      },
      {
        path: 'paymentTips',
        name: 'paymentTips',
        component: () => import('../views/personal/paymentTips'),
        meta: {
          hiddenFooter: true
        }
      }
    ]
  }
];

export {
  routerObject
}

export default new Router({ routes: routerObject, mode: 'history' })



// WEBPACK FOOTER //
// ./src/router/index.js